import { Button, Icon, TableBody, TableItem, Text } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { messageError } from '../../../../../../Resume/utils';
import { handleExportSentOrder, rowHeight, widthCols } from '../constants';

import { StatusIcon } from './StatusIcon';

import { SentOrderItemProps } from '.';

export const Desktop: React.FC<SentOrderItemProps> = ({ order, onSelect }) => {
  return (
    <TableBody testId={'table-order-history-body'} height={rowHeight.desktop} spaceX="inset.xs">
      <TableItem testId={'table-order-history-order-id'} width={widthCols.document.desktop}>
        <Pressable testID="order-history-button-icon" onPress={() => handleExportSentOrder(order)}>
          <Icon
            testID="order-history-icon"
            name="Pdf"
            size="xs"
            color={Color['brand.tertiary.principal']}
          />
        </Pressable>
      </TableItem>
      <TableItem testId={'table-order-history-order-id'} width={widthCols.orderId.desktop}>
        <Text>{order?.orderHash || messageError}</Text>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.sentDate.desktop}>
        <Text>{order.orderDateNormalized}</Text>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.customerName.desktop}>
        <Text>{order.customerNormalized.customerNameNormalized}</Text>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.account.desktop}>
        <Text>{order.accountNormalized.custodyNumberNormalized}</Text>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.product.desktop}>
        <Text>{order.marketTypeNormalized}</Text>
      </TableItem>
      <TableItem
        testId={'table-order-history-create-date'}
        align="center"
        width={widthCols.sentValue.desktop}>
        <Text>{order.requestedAmountNormalized}</Text>
      </TableItem>
      <TableItem testId={'table-order-history-order-id'} width={widthCols.status.desktop}>
        <StatusIcon order={order} withText />
      </TableItem>
      <TableItem testId={'table-order-history-applied-value'} width={widthCols.details.desktop}>
        <Button
          color={Color['brand.tertiary.principal']}
          variant="textLink"
          onPress={() => onSelect(order)}
          rightIcon={
            <Icon
              name="ChevronRight"
              size="xxxs"
              testID="icon"
              color={Color['brand.tertiary.principal']}
            />
          }>
          DETALHES
        </Button>
      </TableItem>
    </TableBody>
  );
};
